import classNames from "classnames";
import { memo } from "react";

// Components
import Checkbox from "components/atoms/Checkbox";

import "./styles.sass";

export type ProviderFilterItemProps = {
  active: boolean;
  name: string;
  // eslint-disable-next-line react/no-unused-prop-types
  count?: number;
  onClick?: (name: string, value: boolean) => void;
};

const BANGER_COVERS = [
  "https://diswdgcu9cfva.cloudfront.net/providers_logo/mini/banger_cover_1.svg",
  "https://diswdgcu9cfva.cloudfront.net/providers_logo/mini/banger_cover_2.svg",
  "https://diswdgcu9cfva.cloudfront.net/providers_logo/mini/banger_cover_4.svg",
  "https://diswdgcu9cfva.cloudfront.net/providers_logo/mini/banger_cover_4.svg",
];

const GLORY_COVERS = [
  "https://diswdgcu9cfva.cloudfront.net/providers_logo/mini/glory_cover_1.svg",
  "https://diswdgcu9cfva.cloudfront.net/providers_logo/mini/glory_cover_2.svg",
  "https://diswdgcu9cfva.cloudfront.net/providers_logo/mini/glory_cover_4.svg",
  "https://diswdgcu9cfva.cloudfront.net/providers_logo/mini/glory_cover_4.svg",
  "https://diswdgcu9cfva.cloudfront.net/providers_logo/mini/glory_cover_5.svg",
  "https://diswdgcu9cfva.cloudfront.net/providers_logo/mini/glory_cover_6.svg",
  "https://diswdgcu9cfva.cloudfront.net/providers_logo/mini/glory_cover_7.svg",
  "https://diswdgcu9cfva.cloudfront.net/providers_logo/mini/glory_cover_8.svg",
];

const BANGER_ICON = [
  "macawgaming",
  "spribe",
  "mascot",
  "thunderkick",
  "netent",
  "lotto-instant-win",
  "elysiumstudios",
  "evolution",
  "evolution2",
  "gamzix",
  "truelab",
  "wazdan",
  "fortune-factory-studios",
  "jftw",
  "switch-studios",
];

const ProviderFilterItem = (props: ProviderFilterItemProps) => {
  const { active, name, onClick } = props;
  const { VITE_APP_PROJECT_NAME } = import.meta.env;
  const isBanger = VITE_APP_PROJECT_NAME === "banger";

  const handleClick = () => {
    if (onClick) {
      onClick(name, !active);
    }
  };

  const providerFilterClass = classNames("ProviderFilterItem", {
    active,
  });

  const currentName = name.toLowerCase().replaceAll(" ", "-");

  let image = `https://diswdgcu9cfva.cloudfront.net/providers_logo/mini/${currentName}.svg`;

  const cover =
    VITE_APP_PROJECT_NAME === "banger"
      ? BANGER_COVERS[Math.floor(Math.random() * BANGER_COVERS.length)]
      : GLORY_COVERS[Math.floor(Math.random() * GLORY_COVERS.length)];

  const isBangerIcon = BANGER_ICON.find((item) => item === currentName);

  if (isBangerIcon && isBanger) {
    image = `https://diswdgcu9cfva.cloudfront.net/providers_logo/mini/${currentName}_${VITE_APP_PROJECT_NAME}.svg`;
  }
  return (
    <div className={providerFilterClass} onClick={handleClick}>
      <div className="ProviderFilterItem__checkbox">
        <Checkbox
          name={`provider-check-${name}`}
          mode={
            import.meta.env.VITE_APP_PROJECT_NAME === "banger"
              ? "dark"
              : "light"
          }
          checked={active}
        />
      </div>
      <div className="ProviderFilterItem__icon">
        <img
          src={image}
          alt={`${name}-icon`}
          onError={({ currentTarget }) => {
            // eslint-disable-next-line no-param-reassign
            currentTarget.onerror = null; // prevents looping
            // eslint-disable-next-line no-param-reassign
            currentTarget.src = cover;
          }}
        />
      </div>
      <div className="ProviderFilterItem__name">{name}</div>
    </div>
  );
};

export default memo(ProviderFilterItem);
